import { Reveal } from '../../../components/Reveal.jsx'
import { EyebrowLabel } from '../../../components/EyebrowLabel.jsx'

const cards = [
  {
    title: 'Real providers',
    body: 'Board-certified MDs, DOs, and NPs licensed in your state — with names, faces, and credentials you can verify.',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M16 11a4 4 0 1 0-8 0M4 20a8 8 0 0 1 16 0" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
  {
    title: 'Full supervision',
    body: 'Labs, ongoing monitoring, and dose adjustments. This is real care — not fire-and-forget.',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M12 3v18M5 8l7-4 7 4M5 8v9l7 4 7-4V8" />
      </svg>
    ),
  },
  {
    title: 'Licensed pharmacies only',
    body: 'Every medication is a patient-specific prescription from a verified 503A pharmacy. Prescription-only, always.',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M12 2 4 5v6c0 5 3.4 8.5 8 10 4.6-1.5 8-5 8-10V5z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
  {
    title: 'Transparent pricing',
    body: 'All-inclusive monthly plans from $199. No surprise fees, cancel anytime. You only pay if a provider prescribes.',
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M8 7V5a4 4 0 0 1 8 0v2M6 10h12l-1 11H7z" />
      </svg>
    ),
  },
]

export function ClinicalTrust() {
  return (
    <section className="bg-white py-[104px] max-[640px]:py-14">
      <div className="hb-wrap">
        <div className="mx-auto mb-[60px] max-w-[600px] text-center max-[640px]:mb-8">
          <Reveal>
            <EyebrowLabel>Why It Matters</EyebrowLabel>
            <h2 className="mt-4 font-serif text-[clamp(32px,4.2vw,50px)] font-semibold leading-[1.08] tracking-[-0.5px] text-[#191A17]">
              Not all telehealth is <em className="hl text-teal-600">created equal.</em>
            </h2>
            <p className="mx-auto mt-[18px] text-[18px] leading-[1.7] text-[#6B6B6B] max-[640px]:mt-3 max-[640px]:text-[15px]">
              HealBerry was built to the highest clinical and pharmacy standards in the industry —
              here&apos;s what that actually means for you.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-5 max-[640px]:gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((card, i) => (
            <Reveal key={card.title} delay={i * 60}>
              <div className="h-full rounded-[20px] border-[1.5px] border-[#E8F1F0] bg-white px-6 py-7 shadow-[0_2px_16px_rgba(0,128,128,0.07)] transition hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,128,128,0.14)] max-[640px]:px-5 max-[640px]:py-5">
                <div className="mb-4 grid h-[50px] w-[50px] place-items-center rounded-[14px] bg-teal-50 text-teal-600 max-[640px]:mb-3 max-[640px]:h-11 max-[640px]:w-11">
                  {card.icon}
                </div>
                <h3 className="mb-2 font-serif text-[18px] font-semibold text-[#191A17]">{card.title}</h3>
                <p className="text-[14px] leading-[1.6] text-[#6B6B6B]">{card.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
